import React from 'react';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import FilterItem from './FilterItem';
import { useActiveFilters } from '../hooks/useActiveFilters';
import { useLocationsData } from '../hooks/useLocationsData';

const FilterItemList = () => {
	const labels = useLabels();
	const { isReady, defaultViewState } = useLocationsData();
	const { filters, handleFilterRemove, handleClearAllFilters } =
		useActiveFilters(isReady, defaultViewState);

	const hasRemovableFilters = filters.some((filter) => !filter.isDefault);

	const filterListClassNames = setClassNames([
		'facet-filter-list',
		'mb-0',
		'list-inline',
		filters.length > 0 ? 'mt-5' : ''
	]);

	return (
		<ul className={filterListClassNames}>
			{filters.map((filter) => (
				<li className="my-1" key={`${filter.type}-${filter.id}`}>
					<FilterItem
						{...filter}
						handleFilterRemove={handleFilterRemove}
					/>
				</li>
			))}
			{hasRemovableFilters && (
				<li className="my-1">
					<button
						className="text-link"
						type="button"
						onClick={handleClearAllFilters}
					>
						{labels.get('CLEAR_FILTERS')}
					</button>
				</li>
			)}
		</ul>
	);
};

export default FilterItemList;
